import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  ESCHEMA_TYPES,
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { EventService } from "../../services/EventService";
import { EventDataDTO } from "../../models/event.model";
import { OPTIONS_LOCALE_DATE } from "@/shared/constants/GeneralConstants";
import { SectionGroup } from "@/modules/ServiceTemplate/models/SectionGroup";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import { GroupResponse } from "@/modules/Services/models/GroupResponse";
import DetailsContentDefault from "./components/DetailsContentDefault/DetailsContentDefault.vue";
import GroupServiceFill from "../../../Profile/components/ServicesView/GroupServiceFill/GroupServiceFill.vue";
import SectionServiceFill from "../../../Profile/components/ServicesView/SectionServiceFill/SectionServiceFill.vue";
import Order from "./components/Order/Order.vue";
import Tasks from "./components/Tasks/Tasks.vue";
import { TaskService } from "@/modules/Tasks/services/TaskService";
import { TaskDTO } from "@/modules/Tasks/models/TaskDTO";
import { TYPE_DETAILS } from "../../constants/EventConstants";
import { MODAL_DETAIL_CONSTANTS } from "./constants/ModalDetailConstants";
import { FormsService } from "@/modules/Forms/services/FormService";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { FormSchema } from "@/shared/models/FormSchema";
import { FieldSchema } from "@/shared/models/FieldSchema";
import { AxiosError } from "axios";
import { FORMS_ACCESS } from "@/modules/Forms/constants/FormsConstants";

Vue.use(Vuetify);
@Component({
  name: "ModalDetails",
  components: {
    DetailsContentDefault,
    GroupServiceFill,
    SectionServiceFill,
    Order,
    Tasks,
    FormModalViewer
  }
})
export default class ModalDetails extends Vue {
  @Inject() eventService!: EventService;
  @Inject() servicesService!: ServicesService;
  @Inject() taskService!: TaskService;
  @Inject() formsService!: FormsService;
  @Inject() formTemplateService!: FormTemplateService;

  @Prop() private userId!: string;
  @Prop() private showModalDetails!: boolean;
  @Prop() eventData!: EventDataDTO;

  note = "";
  defaultContent = false;
  typeDetails = "";

  options = OPTIONS_LOCALE_DATE;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;

  groups: GroupResponse[] = [];
  fillByStep = false;
  playbook = "";
  formsSaved: string[] = [];
  sessionId = "";

  sections: SectionGroup[] = [];
  serviceCompleted = true;
  chosenService = "";
  formTemplateData: FormTemplateData = {} as FormTemplateData;
  dateCreated = "";
  dateModified = "";
  formPreview = false;
  dataModel: { [key: string]: number | string | number[] | string[] } = {};
  formTemplate = "";

  task!: TaskDTO;

  orderId!: string;
  orderTitle!: string;

  TYPE_DETAILS = TYPE_DETAILS;

  mounted() {
    this.defaultContent = true;
  }

  async getFormData(id: string) {
    try {
      const response = await this.formsService.getFormModelById(id);
      if (response.code === Http.Found && response.data != null) {
        this.dataModel = response.data.formModel;
        this.formTemplate = response.data.formTemplate;
        this.dateCreated = response.data.dateCreated
          ? new Date(response.data.dateCreated).toLocaleString("es-CO")
          : "";
        this.dateModified = response.data.dateChanged
          ? new Date(response.data.dateChanged).toLocaleString("es-CO")
          : "";
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async showFormTemplateDetails() {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        this.formTemplate
      );

      if (response.code === Http.Found && response.data != null) {
        this.formTemplateData = response.data;
        const allOf = this.fieldsNotEditable(this.formTemplateData.schema);
        this.formTemplateData.schema.allOf = allOf;
        this.formPreview = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  fieldsNotEditable(schema: FormSchema) {
    return schema.allOf.map((element: FieldSchema) => {
      const keys = Object.keys(element.properties);
      for (const key of keys) {
        element.properties[key].readOnly = true;
        if (typeof this.dataModel[key] === ESCHEMA_TYPES.NUMBER) {
          element.properties[key].type = ESCHEMA_TYPES.NUMBER;
        }
      }
      return element;
    });
  }

  async showForm(formId: string) {
    if (formId) {
      await this.getFormData(formId);
      if (this.formTemplate) await this.showFormTemplateDetails();
    }
  }

  closeModalPreview() {
    this.formPreview = false;
    this.defaultContent = true;
  }

  close() {
    this.$emit("modalClose");
    this.note = "";
    this.typeDetails = "";
    this.defaultContent = true;
  }

  goBack() {
    this.typeDetails = "";
    this.defaultContent = true;
  }

  handleCloseModalOrder() {
    this.typeDetails = "";
    this.defaultContent = true;
  }

  async handleGoToDetails() {
    const details: { [x: string]: () => Promise<void> } = {
      orden: async () => {
        this.orderId = this.eventData.refId as string;
        this.orderTitle = this.eventData.title as string;
        this.typeDetails = TYPE_DETAILS.ORDER;
      },
      tarea: async () => {
        if (
          this.eventData.state == MODAL_DETAIL_CONSTANTS.TASK_STATE.COMPLETE
        ) {
          const idTask = this.eventData.refId as string;
          const taskResponse = await this.taskService.getTask(idTask);
          this.task = taskResponse.data;
          this.task.id = idTask;

          this.typeDetails = TYPE_DETAILS.TASKS;
          this.defaultContent = false;
        } else {
          this.defaultContent = true;
        }
      },
      servicio: async () => {
        const responseService = await this.servicesService.getServiceData({
          serviceId: this.eventData.refId as string,
          userId: this.userId
        });
        this.fillByStep = responseService.data?.fillByStep as boolean;

        if (responseService.data?.sections) {
          this.sections = responseService.data?.sections ?? [];
          this.typeDetails = TYPE_DETAILS.SERVICE.SECTION;
        } else {
          this.groups = responseService.data?.groups ?? [];
          this.typeDetails = TYPE_DETAILS.SERVICE.GROUP;
        }
        this.defaultContent = false;
      },
      formulario: async () => {
        await this.showForm(this.eventData.refId ? this.eventData.refId : "");
        this.typeDetails = TYPE_DETAILS.FORM;
        this.defaultContent = false;
      }
    };

    const detail = details[this.eventData.type as string];
    if (detail !== undefined) {
      await detail();
    }
  }
}
